export default __webpack_public_path__ + "static/media/yeah.9e8a2dad.mp3";